<div id="overlay" class="overlay" [ngClass]="{'active': active}"></div>
<div id="loader" class="loader" [ngClass]="{'active': active}">
  <ui-loading-spinner *ngIf="active"></ui-loading-spinner>
</div>
